const BASE_URL = process.env.BACKEND_URL  || "http://localhost:9000"; // Default fallback
// || "http://localhost:9000"
// "https://api.aurumelegance.com:9443"

interface ApiRequestOptions extends RequestInit {
  body?: any;
  headers?: HeadersInit;
}

export async function apiRequest(endpoint: string, options: ApiRequestOptions = {}) {
  const url = `${BASE_URL}${endpoint}`;

  const headers: HeadersInit = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  const config: RequestInit = {
    method: options.method || "GET",
    headers,
    ...(options.body && { body: JSON.stringify(options.body) }),
  };

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
        const contentType = response.headers.get("content-type");
        const data = contentType?.includes("application/json")
          ? await response.json()
          : await response.text();
      
        const error = new Error("API Error");
        (error as any).status = response.status;
        (error as any).body = data;
        throw error;
    }

    return await response.json();
  } catch (err) {
    console.error("API request error:", err);
    throw err;
  }
}
